import styled from "@emotion/styled";
import { color } from "metabase/lib/colors";

export const AggregationLabel = styled.span`
  color: ${color("summarize")};
`;
